
export default {
  data() {
    return {
      isOpenPopup: false,
      checkMark: false,
    }
  },
  methods: {
    openPopup() {
      this.isOpenPopup = !this.isOpenPopup
    },
  },
}
